export const GET_RECENT_INTERACTIONS_REQUEST = 'GET_RECENT_INTERACTIONS_REQUEST';
export const GET_RECENT_INTERACTIONS_SUCCESS = 'GET_RECENT_INTERACTIONS_SUCCESS';
export const GET_RECENT_INTERACTIONS_FAILURE = 'GET_RECENT_INTERACTIONS_FAILURE';
export const GET_CREDIT_AND_DEBT_REQUEST = 'GET_CREDIT_AND_DEBT_REQUEST';
export const GET_CREDIT_AND_DEBT_SUCCESS = 'GET_CREDIT_AND_DEBT_SUCCESS';
export const GET_CREDIT_AND_DEBT_FAILURE = 'GET_CREDIT_AND_DEBT_FAILURE';
export const SEND_REMINDERS_REQUEST = 'SEND_REMINDERS_REQUEST';
export const SEND_REMINDERS_SUCCESS = 'SEND_REMINDERS_SUCCESS';
export const SEND_REMINDERS_FAILURE = 'SEND_REMINDERS_FAILURE';
